import { render, staticRenderFns } from "./SpinnerWave.vue?vue&type=template&id=182df25c&scoped=true&"
import script from "./SpinnerWave.vue?vue&type=script&lang=js&"
export * from "./SpinnerWave.vue?vue&type=script&lang=js&"
import style0 from "./SpinnerWave.vue?vue&type=style&index=0&id=182df25c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182df25c",
  null
  
)

export default component.exports